import { faCalendar, faClock } from '@fortawesome/pro-solid-svg-icons';
import type { CatalogCardMediaIndicator } from '../types';

/**
 * Indicadores por defecto (reloj + calendario) al usar la API antigua `showAvailabilityIndicators`.
 * Reutilizable en historias o consumidores que repliquen el patrón Figma **238:6044**.
 */
export const catalogCardDefaultMediaIndicators: CatalogCardMediaIndicator[] = [
  {
    id: 'availability-clock',
    tooltip: 'Disponibilidad horaria',
    name: faClock,
    size: 'xs',
    color: 'green',
    background: true,
    backgroundColor: 'ui-bg-surface-success-hover',
    backgroundSize: 'md',
  },
  {
    id: 'availability-calendar',
    tooltip: 'Disponibilidad en calendario',
    name: faCalendar,
    size: 'xs',
    color: 'green',
    background: true,
    backgroundColor: 'ui-bg-surface-success-hover',
    backgroundSize: 'md',
  },
];
